import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import CustomCILsTable from "../../components/CILs/CustomCILsTable";





const CustomCILsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Custom CILs" />

       {/* Projects Table */}
        <CustomCILsTable />

      </MasterLayout>
    </>
  );
};

export default CustomCILsPage;
